import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import logoPng from '../../assets/wealthdost-logo.svg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'Experts', href: '#experts' },
    { name: 'Tribes', href: '#tribes' },
    { name: 'Features', href: '#features' },
    { name: 'Join the WealthDost Community', href: '#download' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0F172A]/80 backdrop-blur-xl border-b border-[#334155]/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center" data-testid="navbar-logo">
            <img 
              src={logoPng} 
              alt="WealthDost" 
              className="h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-[#94A3B8] hover:text-[#F8FAFC] transition-colors text-sm font-medium"
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Download Button - Desktop */}
          <a
            href="#download"
            className="hidden md:inline-flex items-center px-6 py-2.5 bg-[#2563EB] hover:bg-[#2563EB]/90 text-white rounded-full text-sm font-medium transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] btn-glow"
            data-testid="navbar-cta"
          >
            Download App
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-[#F8FAFC]"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#0F172A]/95 backdrop-blur-xl border-b border-[#334155]"
          >
            <div className="px-6 py-4 space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="block text-[#94A3B8] hover:text-[#F8FAFC] transition-colors text-base"
                >
                  {link.name}
                </a>
              ))}
              <a
                href="#download"
                className="w-full px-6 py-3 bg-[#2563EB] text-white rounded-full text-sm font-medium text-center"
                data-testid="mobile-cta"
              >
                Download App
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
